import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricHotelsClicks extends MetricBase {
    constructor() {
        super({
            field: "metric_hotel_clicks",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.hotelClicks.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.hotelClicks.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.hotelClicks.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricHotelsClicks;
